import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TCampaignIncentiveSet } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class CampaignIncentiveSetsService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getNullable(): TCampaignIncentiveSet {
        const set: TCampaignIncentiveSet = {
            setName: '',
            incentiveUids: [],
            uid: '',
            incentiveSetId: 0
        };
        return set;
    }

    public getObservable(): Observable<TCampaignIncentiveSet[]> {
        const path = this.firestorePathsService.getCampaignIncentiveSetsPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TCampaignIncentiveSet[]>;
        return observable;
    }

    public async getByUid(uid: string): Promise<TCampaignIncentiveSet> {
        const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
        return this.firestoreService.getByUid(collection, uid) as Promise<TCampaignIncentiveSet>;
    }

    public async getByFieldValue(fieldName: string, fieldValue: any): Promise<TCampaignIncentiveSet[]> {
        const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
        return this.firestoreService.getByFieldValue(collection, fieldName, fieldValue) as Promise<TCampaignIncentiveSet[]>;
    }

    public async getAll(): Promise<TCampaignIncentiveSet[]> {
        const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
        const incentives = await this.firestoreService.getAll(collection) as TCampaignIncentiveSet[];
        const sortedIncentives = this.sort(incentives);
        return sortedIncentives;
    }

    public async add(incentive: TCampaignIncentiveSet): Promise<TCampaignIncentiveSet> {
        const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
        return this.firestoreService.add(collection, incentive) as Promise<TCampaignIncentiveSet>;
    }

    public async update(incentive: TCampaignIncentiveSet): Promise<TCampaignIncentiveSet> {
        const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
        return this.firestoreService.update(collection, incentive) as Promise<TCampaignIncentiveSet>;
    }

    public async delete(uid: string): Promise<void> {
        const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
        return this.firestoreService.delete(collection, uid);
    }

    public sort(incentives: TCampaignIncentiveSet[]): TCampaignIncentiveSet[] {
        const sortedIncentives = incentives.sort((a, b) => {
            if (a.setName < b.setName) {
                return -1;
            } else if (a.setName > b.setName) {
                return 1;
            } else {
                return 0;
            }
        });
        return sortedIncentives;
    }

    // public getByAccountNumber(accountNumber: string): Promise<TCampaignIncentiveSet[]> {
    //     const collection = this.firestorePathsService.getCampaignIncentiveSetsPath();
    //     return this.firestoreService.getAll(collection);
    // }
}
